import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { TransferRequestsApi, type TransferRequestCreateDocumentRequest } from '@shared/api';

const createDocumentEffect = createEffect((request: TransferRequestCreateDocumentRequest) => TransferRequestsApi.createDocument(request));
const clearEvent = createEvent();

const $dataStore = createStore<string>('')
  .on(createDocumentEffect.done, (_, values) => values.result.data)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(createDocumentEffect.pending, (_, data) => data)
  .on(createDocumentEffect.fail, () => false)
  .on(createDocumentEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(createDocumentEffect, () => null)
  .on(
    createDocumentEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while creating Document. Please try again.').message,
  )
  .on(createDocumentEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $transferRequestsUploadFileStore = {
  events: {
    createDocument: createDocumentEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
